export default "https://cdn-gra-staging.amplement.io/statics/images/browsers/chrome.png";